// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.detailcot[data-v-a8c45ebc] {\r\n  overflow-y: scroll;\r\n  overflow-x: hidden;\r\n  height: 100%;\r\n  line-height: 18px;\n}\r\n", ""]);
// Exports
module.exports = exports;
